import { detectIncognito } from 'detectincognitojs';

/**
 * Best-effort private/incognito browsing detection, delegated to detectincognitojs
 * (per-engine heuristics: IndexedDB durability timing on Chromium, OPFS errors on
 * Firefox/Safari). Private windows get their own storage partition, so
 * BroadcastChannel (and with it the duplicate-tab lock) can't see an exam running
 * in a normal window. Blocking private browsing closes that gap. Fails open: when
 * the library can't identify the browser or throws, we assume normal browsing
 * rather than lock a candidate out on a guess.
 */
let cachedResult: Promise<boolean> | null = null;

export function detectPrivateBrowsing(): Promise<boolean> {
  // The answer can't change for the lifetime of the page.
  cachedResult ??= detectIncognito()
    .then(({ isPrivate, browserName }) => {
      // console.log('[PB-DEBUG] detectIncognito:', { browserName, isPrivate }); // TEMP-DEBUG
      return isPrivate;
    })
    .catch((error) => {
      console.warn('[PB-DEBUG] detection threw, failing open (not blocking):', error); // TEMP-DEBUG
      return false;
    });
  return cachedResult;
}
